import { render } from "./GameInprogressRow.vue?vue&type=template&id=1f248462&scoped=true"
import script from "./GameInprogressRow.vue?vue&type=script&lang=js"
export * from "./GameInprogressRow.vue?vue&type=script&lang=js"

import "./GameInprogressRow.vue?vue&type=style&index=0&id=1f248462&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f248462"]])

export default __exports__